import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CustomBox } from '../../components/Tutor/style';
import Text from '../Text';
import InputLegend from '../InputLegend';
import CustomInput from '../CustomInput';
import CTA from '../CTA';
import ActivityBox from '../ActivityBox';
import {
  ADD_ACTIVITY,
  DEL_SECTION,
  UPDATE_SECTION,
} from '../../../app/redux/actions/tutors';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';

const SessionBox = ({
  viewMode,
  mediaIsPhone,
  index,
  delSection,
  updateSection,
  sections,
  sectionKey,
  addActivity,
}) => {
  const section = sections[sectionKey] || {};

  useEffect(() => {
    if (Object.keys(section?.activities || {})?.length <= 0) {
      addActivity(sectionKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionKey]);

  const sortActivities = (a, b) => {
    if (section.activities[a]?.type === 'activity_quiz') return 1;
    if (section.activities[b]?.type === 'activity_quiz') return -1;
    if (
      !(section.activities[a]?.order >= 0 || section.activities[b]?.order >= 0)
    ) {
      return 0;
    }
    return section.activities[a].order - section.activities[b].order;
  };

  return (
    <CustomBox className="mb-4">
      <div className="d-flex sb">
        <Text type="h2" mb={24}>
          Sessione {index}
        </Text>
        {index > 1 && !viewMode && (
          <CTA
            type="tertiary"
            btnText="Elimina"
            icon="trash-01"
            onClick={() => delSection(sectionKey)}
          />
        )}
      </div>
      <InputLegend
        label="Titolo sessione"
        tooltipKey="event_session_title"
        type="secondary"
        required
        htmlFor="event-session-title"
      />
      {viewMode ? (
        <Text type="b3">{section?.title}</Text>
      ) : (
        <CustomInput
          size={mediaIsPhone ? 'full' : 'm'}
          placeholder="Inserisci"
          onChange={(newValue) => updateSection(sectionKey, 'title', newValue)}
          value={section?.title}
          id="event-session-title"
        />
      )}
      {Object.keys(section.activities || {})
        .sort(sortActivities)
        .map((k, i) => (
          <ActivityBox
            key={`activity-${sectionKey}-${i}`}
            index={i + 1}
            sectionKey={sectionKey}
            activityKey={k}
            isEvent
            viewMode={viewMode}
          />
        ))}
      {Object.values(section.activities).findIndex(
        ({ type }) => type === 'activity_quiz'
      ) < 0 &&
        !viewMode && (
          <CTA
            type="tertiary"
            btnText="Aggiungi un quiz"
            icon="plus"
            onClick={() => addActivity(sectionKey, 'activity_quiz')}
          />
        )}
    </CustomBox>
  );
};

SessionBox.propTypes = {
  viewMode: PropTypes.bool,
  mediaIsPhone: PropTypes.bool,
  index: PropTypes.number,
  sections: PropTypes.object,
  sectionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  updateSection: PropTypes.func,
  delSection: PropTypes.func,
  addActivity: PropTypes.func,
};

export default connect(
  (state) => {
    const { sections } = state.tutors.activities;
    return { sections };
  },
  (dispatch) => ({
    delSection: (id) => dispatch({ type: DEL_SECTION, id }),
    updateSection: (id, field, value) =>
      dispatch({ type: UPDATE_SECTION, id, field, value }),
    addActivity: (secId, activityType) =>
      dispatch({ type: ADD_ACTIVITY, secId, activityType }),
  })
)(withMediaQueries(SessionBox));
